import { render, staticRenderFns } from "./bay-package.vue?vue&type=template&id=3d5640ac&"
import script from "./bay-package.vue?vue&type=script&lang=js&"
export * from "./bay-package.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports